package pwgs.ui.scenes.playerlogsscene


class PlayerLogsControllerFe(props: PlayerLogsSceneProps, scene: MPlayerLogsScene) : APlayerLogsControllerFe(props, scene) {

    override fun createInitialModel() : PlayerLogsSceneModel {
        return PlayerLogsSceneModel(false, listOf())
    }

    override fun init() {
        call_load()
    }

    fun enableLogging() {
        this.model.isLoading = true
        this.render()
        call_enableLogging()
    }

    fun disableLogging() {
        this.model.isLoading = true
        this.render()
        call_disableLogging()
    }

    fun refresh() {
        this.model.isLoading = true
        this.render()
        call_load()
    }


}

